import { render, staticRenderFns } from "./TierMain.vue?vue&type=template&id=274c8666&scoped=true&"
import script from "./TierMain.vue?vue&type=script&lang=js&"
export * from "./TierMain.vue?vue&type=script&lang=js&"
import style0 from "./TierMain.vue?vue&type=style&index=0&lang=css&"
import style1 from "./TierMain.vue?vue&type=style&index=1&id=274c8666&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "274c8666",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\Globaltask\\Documents\\Happybox Store\\Happybox Site\\collection-gifting\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('274c8666')) {
      api.createRecord('274c8666', component.options)
    } else {
      api.reload('274c8666', component.options)
    }
    module.hot.accept("./TierMain.vue?vue&type=template&id=274c8666&scoped=true&", function () {
      api.rerender('274c8666', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "CollectionGifting/components/GOCPreview/Tier/TierMain.vue"
export default component.exports